import {Injectable} from '@angular/core';

import {AItCreerRgReponseParametres, AItRgMessage} from './DonneesTraitements';
import {ValAppSettingsService} from '../../../../val-ammon-services/val-app-settings-lib/src/public-api';
import {ValApiResultat, ValBaseService} from '../../../../val-ammon-services/val-services-communs-lib/src/public-api';

//Service Ammon Interact
@Injectable (
{
  providedIn: 'root'
})
export class AmmonInteractRgServiceService extends ValBaseService 
{
  //Création
  //  Paramètres
  //    appSettingsService : Service d’accès à la configuration de l’application
  //    httpClient         : Client HTTP
  constructor (private appSettingsService: ValAppSettingsService) 
  {
    super ();
  }

  //Url de base
  protected override get BaseUrl () : string 
  {
    return `${this.appSettingsService.Configuration.UrlApi.Interact}/v1.0/rg/sessions/` ;
  }

  //Retourne les RG message
  //  Paramètres
  //    identifiantSession : Identifiant de la session
  //  Retourne
  //    Résultat de la récupération des RG message
  public async RetournerRgMessages (identifiantSession: string) : Promise<ValApiResultat<AItRgMessage[]>> 
  {
    let operation: Promise<ValApiResultat<AItRgMessage[]>>;

    operation = this.ExecuterRequeteGet<AItRgMessage[]> (identifiantSession);

    return operation;
  }

  //Crée une RG réponse
  //  Paramètres
  //    aitCreerRgReponseParametres : Paramètres de création d’une RG réponse
  //  Retourne
  //    Résultat de la création d’une RG réponse
  public async CreerRgReponse (aitCreerRgReponseParametres: AItCreerRgReponseParametres) : Promise<ValApiResultat<any>> 
  {
    let operation: Promise<ValApiResultat<any>>;

    operation = this.ExecuterRequetePost<any> ("reply", aitCreerRgReponseParametres);

    return operation;
  }
}
